import { render, staticRenderFns } from "./EmployerMatchAgeRequirementSelect.vue?vue&type=template&id=31977a50&"
import script from "./EmployerMatchAgeRequirementSelect.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchAgeRequirementSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports